/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownItemProps } from 'semantic-ui-react';
import { SerializedStyles } from '@emotion/react';
import style from '../../users/components/adUserDropdownField.style';
import { DistributionListGroup } from '../../distributionListGroup/models/distributionListGroup';

interface DistributionListGroupsDropDownProps {
  groups: DistributionListGroup[];
  onChange: (group?: DistributionListGroup) => void;
  value: string;
  cornerIcon: string;
  placeholder: string;
  defaultValue?: DistributionListGroup;
  isFetching: boolean;
  css?: SerializedStyles;
  clearable?: boolean;
}

export const DistributionListGroupsDropDown = ({
  groups,
  onChange,
  value,
  cornerIcon,
  placeholder = '',
  defaultValue,
  isFetching,
  css,
  clearable=false
}: DistributionListGroupsDropDownProps): JSX.Element => {
  const [currentValue, setCurrentValue] = useState(value)
  const cssStyle = css ?? cornerIcon ? style.adUserDropdownCornerIcon : style.adUserDropdown;

  const generateItemOptions = (distributionGroups: DistributionListGroup[]): DropdownItemProps[] => {
    const generateItem = (group: DistributionListGroup): DropdownItemProps => {
      return {
        key: group.name,
        value: group.name,
        text: group.name,
        content: (
          <div>
            <div css={style.dropdownItemName}>{group.name}</div>
            <div>{group.brand.description}</div>
          </div>
        ),
      };
    };

    return distributionGroups.map(generateItem);
  };

  const [options, setOptions] = useState<DropdownItemProps[]>(generateItemOptions(groups));

  useEffect(() => {
    if (value === '') {
      setCurrentValue('');
      setOptions([]);
    }
  }, [value]);


  return (
    <Dropdown
        value={currentValue}
        icon={cornerIcon}
        css={cssStyle}
        selection
        fluid
        search
        options={options}
        placeholder={placeholder}
        defaultValue={defaultValue?.distributionList.map((c) => c.email)}
        onChange={(e, { value: optionValue }) => {
            const selected = optionValue as string;
            const distributionListGroup = groups.find(g => g.name === selected);
            setCurrentValue(selected)
            onChange(distributionListGroup);
        }}
        onFocus={() => {
            if (!options.length) {
            setOptions(generateItemOptions(groups));
            }
        }}
        onSearchChange={(e, { searchQuery }) => {
            if (searchQuery.trim() === '') {
            setOptions(generateItemOptions(groups));
            } else {
            const filtered = groups.filter(group =>
                group.name.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setOptions(generateItemOptions(filtered));
            }
        }}
        selectOnBlur={false}
        onBlur={() => {
          if (currentValue === '') {
            setOptions([]);
          }
        }}
        loading={isFetching}
        clearable={clearable}
    />
  );
};
